module.exports = __webpack_public_path__ + "static/surfrider-d0210e22f046a063c45f24864eaf9960.png";